import * as React from 'react';
import styled from '@emotion/styled';
import Carrusel from './Carrusel';
import ImgNat from "../assets/images/About/IMGV-Natalia.png";
import ImgCaro from "../assets/images/About/IMGV-Caro.png";
import ImgRaul from "../assets/images/About/IMGV-Raul.png";
import ImgCas from "../assets/images/About/IMGV-Cas.png";
import ImgAna from "../assets/images/About/IMGV-Ana.png";
import ImgKat from "../assets/images/About/IMGV-Kat.png";
import ImgItza from "../assets/images/About/IMGV-Itza.png";
import ImgJon from "../assets/images/About/IMGV-Jon.png";
import ImgPablo from "../assets/images/About/IMGV-Pablo.png";
import ImgOsmar from "../assets/images/About/IMGV-Osmar.png";
import ImgNat1 from "../assets/images/About/IMGV-Nat.png";


const CNCSections = () => {

const Title = styled.p`
    font-family: "Oswald", serif;
    font-size: 35px;
    color: black;
    border-bottom: 3px solid #005522;
    display: inline-block;
    margin-bottom: 0;
`;
const SubTitle = styled.p`
    font-family: "Oswald", serif;
    font-size: 20px;
    color: #005522;
    display: block;
    margin-top: 5px;
`;

const SectionsDiv = styled.div`
    background: #ededed;
    padding-bottom: 50px;
    display:block;
`;

const Descripcion = styled.p`
    font-family: "DM Sans", serif;
    font-size: 15px;
    color: black;
    display: inline-block;
    padding: 20px;
    width: 80%;
    margin: auto;
`;

const cards = [
    { title: "COORDINADORA NACIONAL DE CAPACITACIÓN", content: "La Coordinadora Nacional de Capacitación lidera los tres niveles de Capacitación, supervisa al Equipo Nacional y las Coordinaciones Estatales.", 
        image: ImgNat },
    { title: "RESPONSABLE NACIONAL DE GESTIÓN DE CALIDAD", content: "Supervisor y mejora procesos académicos, administrativos y operativos, asegurando la calidad, cumplimiento de la normatividad e identificando áreas de oportunidad.", 
        image: ImgPablo  },
    { title: "RESPONSABLE NACIONAL DE OP. ADMIN. Y ESTADÍSTICA", content: "Encargado de los registros financieros, presupuestos, reportes anuales, elabora estadísticas de desempeño.", 
        image: ImgRaul },
    { title: "RESPONSABLE NACIONAL DE CENTROS DE CAPACITACIÓN", content: "Supervisa, asesora y valida la operación de los centros de capacitación, así como la ratificación de los mismos. Así mismo, ejecuta los procedimientos relacionados al Área.", 
        image: ImgNat1 },
    { title: "RESPONSABLE NACIONAL DE FORMACIÓN ACADÉMICA", content: "Desarrolla y actualiza planes de estudio con enfoque en calidad y calidez. Así mismo, valida cursos y programas formativos con el enfoque pedagógico.", 
        image: ImgAna },
        { title: "RESPONSABLE NACIONAL AREA DE INNOVACION DIGITAL", content: "Administra, gestiona y supervisa la capacitación en línea a través de la plataforma digital nacional, impulsando la innovación tecnológica en los procesos formativos y coordinando al personal estatal especializado en el sistema.", 
            image: ImgOsmar },
        { title: "RESPONSABLE NACIONAL DE VINCULACIÓN Y OPERACIÓN ESTRATÉGICA DE CAPACITACIÓN", content: "Responsable del diseño, gestión e implementación de programas de capacitación externa en Primeros Auxilios, Protección Civil y emergencias, con cursos avalados por Cruz Roja Mexicana. Supervisa proyectos, coordina recursos y asegura estándares de calidad. Gestiona la operación CONOCER en certificación de competencias laborales y lidera la estrategia nacional de capacitación externa, fortaleciendo la vinculación institucional y la sostenibilidad del CENCAD.", 
            image: ImgCas },
        { title: "RESPONSABLE NACIONAL DE CAPACITACIÓN CONTINUA", content: "Gestiona, coordina y valida cursos especializados con certificaciones nacionales e internacionales, entre los cuales se encuentra la FONE, AHA y NAEMT.", 
            image: ImgJon },
  ];


  return (
    <SectionsDiv>
    <Title initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }} 
    transition={{ duration: 0.6, ease: "easeOut" }}
    viewport={{ once: true }}> 
    ÁREAS NACIONALES<br/></Title>
    <SubTitle initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }} 
    transition={{ duration: 0.6, ease: "easeOut" }}
    viewport={{ once: true }}> 
    DE LA COORDINACIÓN NACIONAL DE CAPACITACIÓN</SubTitle>
    <Descripcion>Para un mejor desempeño, la Coordinación Nacional de Capacitación cuenta con siete áreas nacionales, lideradas por una responsable que coordina y supervisa su labor. Cada área cumple un rol fundamental en la formación y profesionalización, garantizando que el trabajo de la Coordinación de Capacitación en todos los niveles se distinga por su calidad y calidez.</Descripcion>
    <Carrusel cards={cards } LinkTo="Nosotros"></Carrusel>
    </SectionsDiv>
  );
};

export default CNCSections;